import React, { useEffect } from 'react';
import { useState } from 'react';
import './App.css';
import { CourseMap } from './components/coursemap';
import { Sidebar } from './components/sidebar';
import { SkeletonLoader } from './components/skeleton-loader';
import { MobileBlock } from './components/mobile-block';


function App() {
  const [focusedNode, setFocusedNode] = useState()
  const [LoadCompleted, SetLoadCompleted] = useState<boolean>(false)
  const [ViewerRendered, SetViewerRendered] = useState<boolean>(false)
  const [showSideBar, setShowSidebar] = useState<boolean>(false)

  const setFocusedNodeWrapper = (node) => {
    setFocusedNode(node)
  }

  useEffect(() => {
    setShowSidebar(!(focusedNode === undefined || focusedNode === null))
  }, [focusedNode])


  return (
    <div className="App">
      {(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) && <MobileBlock />}
      {!(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) && !(LoadCompleted) && <SkeletonLoader></SkeletonLoader>}

      <CourseMap
        width={window.innerWidth}
        height={window.innerHeight}
        SetFocusedNode={setFocusedNodeWrapper}
        SetLoadCompleted={SetLoadCompleted}
        LoadCompleted={LoadCompleted}
        ViewerRendered={ViewerRendered}
        SetViewerRendered={SetViewerRendered}
      />


      {showSideBar && <Sidebar focusedNode={focusedNode} setFocusedNode={setFocusedNode} />}

    </div>
  );
}

export default App;
